import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const obtenerToken = () => {
    return localStorage.getItem('jwt').replaceAll('"', '');
};

const obtenerConfig = () => ({
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        Authorization: 'Bearer ' + obtenerToken()
    }
});

const URL = `${BASE_URL}/siniestroFuente`;

/** Sube uno o varios archivos a la fuente. archivos: File[] */
export const subirArchivosFuente = async (siniestroFuenteId, archivos) => {
    const formData = new FormData();
    archivos.forEach((file) => formData.append('archivos', file));

    const response = await axios.post(`${URL}/${siniestroFuenteId}/archivos`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + obtenerToken()
        }
    });
    return response.data;
};

/** Lista los archivos activos de una fuente (metadata). */
export const listarArchivosFuente = async (siniestroFuenteId) => {
    const response = await axios.get(`${URL}/${siniestroFuenteId}/archivos`, obtenerConfig());
    return response.data;
};

/** Descarga el binario del archivo. Devuelve un Blob. */
export const descargarArchivoFuente = async (archivoId) => {
    const response = await axios.get(`${URL}/archivo/${archivoId}/descargar`, {
        headers: { Authorization: 'Bearer ' + obtenerToken() },
        responseType: 'blob'
    });
    return response;
};

/** Anula (eliminacion logica) el archivo. */
export const anularArchivoFuente = async (archivoId) => {
    const response = await axios.get(`${URL}/archivo/anular/${archivoId}`, obtenerConfig());
    return response.data;
};

/**
 * Helper de UI: dispara la descarga del archivo en el navegador con el nombre original.
 * Si es imagen o PDF, abre en nueva pestaña para preview.
 */
export const descargarOAbrirArchivo = async (archivo) => {
    const response = await descargarArchivoFuente(archivo.siniestroFuenteArchivoId);
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);

    const tipo = (archivo.tipoMime || '').toLowerCase();
    const esVistaInline = tipo.startsWith('image/') || tipo === 'application/pdf';

    if (esVistaInline) {
        // Abrir en nueva pestaña
        window.open(url, '_blank');
        // Liberar URL despues de un tiempo para permitir que la pestaña la lea
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } else {
        // Descargar
        const link = document.createElement('a');
        link.href = url;
        link.download = archivo.nombreArchivo || `archivo_${archivo.siniestroFuenteArchivoId}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
};
